import * as React from "react";
const SvgReducer = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 70, height: 50, viewBox: "0 0 70.0 50.0", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 0.0 0.0 L 70.0 25.0 L 0.0 50.0 Z", fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgReducer;
